import { IconProps } from './icons';

export const CheckIcon = ({ color = '#0085FF', height = 15, width = 22 }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 15" fill="none" style={{ width: `${width}px` }}>
      <path
        d="M1 7.84211L8.14286 14L21 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
